var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { UsersApiService } from '@ClientApi/users';
export const ADD_MANAGERS = 'ADD_MANAGERS';
export const SET_MANAGERS_LOADING = 'SET_MANAGERS_LOADING';
export class AddManagers {
    constructor(payload) {
        this.payload = payload;
        this.type = ADD_MANAGERS;
    }
}
export class SetManagersLoading {
    constructor(payload) {
        this.payload = payload;
        this.type = SET_MANAGERS_LOADING;
    }
}
export const getAllManagers = (dispatch, state) => (forceReload = false) => __awaiter(void 0, void 0, void 0, function* () {
    if (!forceReload) {
        const { managersLoading, managers } = state.managers;
        if (managersLoading || managers.length) {
            return;
        }
    }
    dispatch(new SetManagersLoading(true));
    const users = yield UsersApiService.getAll();
    const managers = [];
    users.forEach((user) => {
        if (!user.is_active) {
            return;
        }
        if (!user.user_profile.can_manager_approve && !user.user_profile.is_admin && user.user_profile.role !== 'manager') {
            return;
        }
        managers.push(user);
    });
    dispatch(new AddManagers(managers));
    dispatch(new SetManagersLoading(false));
});
